import { render, staticRenderFns } from "./ModalAddPatient.vue?vue&type=template&id=057e11d2&scoped=true"
import script from "./ModalAddPatient.vue?vue&type=script&lang=js"
export * from "./ModalAddPatient.vue?vue&type=script&lang=js"
import style0 from "./ModalAddPatient.vue?vue&type=style&index=0&id=057e11d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057e11d2",
  null
  
)

export default component.exports